import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.features.length
    ? _c(
        "section",
        {
          staticClass: "lpu-features d-flex flex-column",
          class: _setup.isMobile ? "ga-5" : "ga-8",
          attrs: { id: "features", "data-qa": "lpu_features" },
        },
        [
          _c(
            "h2",
            {
              ref: "titleRef",
              staticClass: "text--text",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_features_title" },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.tStatic("Особенности клиники")) +
                  "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column ga-6" }, [
            _c(
              "div",
              { staticClass: "lpu-features__lists d-flex flex-column ga-6" },
              [
                _c(
                  "div",
                  {
                    class: _setup.isMobile
                      ? "d-flex flex-column ga-6"
                      : "lpu-features__list--desktop",
                  },
                  _vm._l(_setup.collapsedFeatures, function (feature) {
                    return _c(_setup.FeatureItem, {
                      key: feature.key,
                      attrs: { feature: feature },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(VExpandTransition, [
                  _setup.isExpanded && _setup.expandedFeatures.length
                    ? _c(
                        "div",
                        {
                          class: _setup.isMobile
                            ? "d-flex flex-column ga-6"
                            : "lpu-features__list--desktop",
                        },
                        _vm._l(_setup.expandedFeatures, function (feature) {
                          return _c(_setup.FeatureItem, {
                            key: feature.key,
                            attrs: { feature: feature },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _setup.hasHiddenFeatures
              ? _c(
                  "button",
                  {
                    staticClass:
                      "lpu-features__toggle align-self-start d-inline-flex align-center ga-3 text-body-1",
                    class: _setup.ff_lpu_branding_page_v5
                      ? "text-lpu-branding-color-text"
                      : "text-lpu-branding-color-primary",
                    attrs: { type: "button", "data-qa": "lpu_features_toggle" },
                    on: { click: _setup.toggleExpanded },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.isExpanded
                              ? _setup.tStatic("Свернуть все особенности")
                              : _setup.tStatic("Показать все особенности")
                          ) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", {
                      staticClass:
                        "ui-icon-arrow-down ui-icon-fz-big flex-shrink-0",
                      class: {
                        "lpu-features__toggle-icon--expanded":
                          _setup.isExpanded,
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }